<template>
  <div id="app">
   

    <AppHeader
      v-if="!isLoginPage"
      :navList="navList"
      :webName="webName"
      :webLogo="webLogo"
      :webDownloadUrl="webDownloadUrl"
      :wxQrUrl="wxQrUrl"
    />
    <main class="app-main">
      <router-view />
    </main>
    <BackToTop
      v-if="!isLoginPage"
      :webDownloadUrl="webDownloadUrl"
      :wxQrUrl="wxQrUrl"
    />
    <AppFooter
      v-if="!isLoginPage"
      :friendLinks="friendLinks"
      :siteLinks="aboutList"
      :footerContent="footerContent"
    />
  </div>
</template>

<script>
import AppHeader from "./components/AppHeader.vue";
import AppFooter from "./components/AppFooter.vue";
import BackToTop from "./components/BackToTop.vue";
import { getWebSet, imgBaseURL } from "@/api";

export default {
  name: "App",
  components: {
    AppHeader,
    AppFooter,
    BackToTop,
  },
  data() {
    return {
      navList: [],
      webName: "",
      webLogo: "",
      webDownloadUrl: "",
      wxQrUrl: "",
      friendLinks: [],
      aboutList: [],
      footerContent: "",
    };
  },
  computed: {
    isLoginPage() {
      return this.$route.path === "/login";
    },
  },
  created() {
    this.fetchWebSet();
  },
  methods: {
    fetchWebSet() {
      getWebSet()
        .then((res) => {
          if (res.code === 1 || res.code === 200) {
            const data = res.data;
            // 头部导航
            this.navList = data.head_class_list || [];
            // 网站信息
            this.webName = data.web_set?.web_name || "";
            this.webLogo = imgBaseURL + (data.web_set?.web_logo || "");
            this.webDownloadUrl =
              imgBaseURL + (data.web_set?.web_download_url || "");
            this.wxQrUrl = imgBaseURL + (data.web_set?.wx_gz_qr_url || "");
            // 脚部信息
            this.friendLinks =
              (data.partner_link || []).map((item) => ({
                text: item.name,
                href: item.url,
              })) || [];
            this.aboutList = data.foot_about_list || [];
            this.footerContent = data.web_set?.footer_content || "";
          }
        })
        .catch((err) => {
          console.error("获取网站配置失败:", err);
        });
    },
  },
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
#app {
  min-height: 100vh;
}
</style>
